import Vue from 'vue'
import VueRouter from 'vue-router'
import Default from '../views/Default.vue'

Vue.use(VueRouter)

VueRouter.prototype.go = function () {
  this.isBack = true
  window.history.go(-1)
}

const routes = [
  {
    path: '/',
    component: Default,
    children: [
      {
        name: 'Home',
        path: '',
        component: () => import('../components/Search/List.vue'),
        meta: {
          title: '災害影像庫',
          keepAlive: true,
          collection: true,
        },
      },
      {
        path: 'c-:code',
        component: () => import('../components/Search/Content.vue'),
        meta: {
          title: '災害影像庫',
          keepAlive: false,
          collection: false,
        },
      },
      {
        name: 'SearchPage',
        path: 'page:page',
        component: () => import('../components/Search/List.vue'),
        meta: {
          title: '災害影像庫',
          keepAlive: true,
          collection: true,
        },
      },
    ],
  },
  {
    path: '/map',
    component: Default,
    children: [
      {
        path: '',
        component: () => import('../components/Map/List.vue'),
        meta: {
          title: '影像地圖',
          keepAlive: true,
          collection: false,
        },
      },
    ],
  },
  {
    path: '/login',
    component: () => import('../components/Collection/Login.vue'),
    meta: {
      title: '登入',
      collection: false,
    },
  },
  {
    path: '/about',
    component: () => import('../components/Page.vue'),
    meta: {
      title: '關於新竹縣災害歷史影像資料庫',
      collection: false,
    },
  },
  {
    path: '/collection',
    component: () => import('../components/Collection/Form.vue'),
    meta: {
      title: '相簿募集',
      collection: false,
    },
  },
]

const router = new VueRouter({
  base: '/storymap',
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: routes,
})

export default router
